import { getPermission } from "./permission";

/** Показывать системные уведомления о сообщениях на компьютере: пользователь разрешил. */
export default function isDesktopNotifyEnabled() {
  return getPermission() === "granted";
}
